(() => {
  const namespace = (window.AcornAnalytics = window.AcornAnalytics || {});
  const config = namespace.config || {};

  const storageKey = config.storageKey || 'acorn-analytics-debug';

  const storage = (() => {
    try {
      const testKey = '__acorn_analytics_storage_test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch (_error) {
      return null;
    }
  })();

  const getStoredPreference = () => {
    if (!storage) return null;

    const value = storage.getItem(storageKey);
    if (value === null) return null;

    return value === 'true';
  };

  const setStoredPreference = (value) => {
    if (!storage) {
      console.warn(
        '[Analytics Tracking] Unable to persist debug preference because localStorage is not available.'
      );
      return;
    }

    if (value === null) {
      storage.removeItem(storageKey);
    } else {
      storage.setItem(storageKey, value ? 'true' : 'false');
    }
  };

  const resolveDebugEnabled = () => {
    const stored = getStoredPreference();
    if (stored !== null) return stored;

    return Boolean(config.debugEnabled);
  };

  const debugEnabled = resolveDebugEnabled();

  Object.assign(namespace, {
    storageKey,
    debugEnabled,
    enableDebug() {
      setStoredPreference(true);
      console.info(
        '[Analytics Tracking] Debug mode enabled. Reload the page to see verbose logging.'
      );
    },
    disableDebug() {
      setStoredPreference(false);
      console.info(
        '[Analytics Tracking] Debug mode disabled. Reload the page to stop verbose logging.'
      );
    },
    resetDebugPreference() {
      setStoredPreference(null);
      console.info(
        '[Analytics Tracking] Debug preference reset. Theme setting now controls debug mode.'
      );
    },
    status() {
      return {
        effective: resolveDebugEnabled(),
        fromLocalStorage: getStoredPreference(),
        fromThemeSetting: Boolean(config.debugEnabled),
        storageKey,
      };
    },
  });

  const renderStatusLog = () => {
    const status = namespace.status();

    console.groupCollapsed('[Analytics Tracking] Initializing analytics tracking...');
    console.log('Effective debug mode:', status.effective);
    console.log('Theme setting debug:', status.fromThemeSetting);
    console.log('Stored preference override:', status.fromLocalStorage);
    console.log('Storage key:', storageKey);
    console.groupEnd();
  };

  if (!debugEnabled) {
    console.debug('[Analytics Tracking] Debug mode is disabled.');
    return;
  }

  renderStatusLog();

  const dataLayer = window.dataLayer;
  if (Array.isArray(dataLayer)) {
    const originalPush = dataLayer.push;
    dataLayer.push = function (...args) {
      console.info('[Analytics Tracking] dataLayer.push', ...args);
      return originalPush.apply(this, args);
    };
  } else {
    console.warn(
      '[Analytics Tracking] dataLayer is not available. Google Analytics calls will not be logged.'
    );
  }

  if (typeof window.gtag === 'function') {
    const originalGtag = window.gtag;
    window.gtag = function (...args) {
      console.info('[Analytics Tracking] gtag()', ...args);
      return originalGtag.apply(this, args);
    };
  } else {
    Object.defineProperty(window, 'gtag', {
      configurable: true,
      set(value) {
        if (typeof value === 'function') {
          const wrapped = function (...args) {
            console.info('[Analytics Tracking] gtag()', ...args);
            return value.apply(this, args);
          };

          Object.defineProperty(window, 'gtag', {
            value: wrapped,
            writable: true,
            configurable: true,
          });
        } else {
          Object.defineProperty(window, 'gtag', {
            value,
            writable: true,
            configurable: true,
          });
        }
      },
      get() {
        return undefined;
      },
    });
  }
})();

